import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faTrash} from "@fortawesome/free-solid-svg-icons";

import './CommentToolTip.css';
import commentsEmptyIcon from "../../../resources/images/comments_empty.png";
import commentsFullIcon from "../../../resources/images/comments_full.png";
import {StandardButton} from "../button/standard-button/StandardButton";
import {
    createComment,
    createView,
    deleteComment,
    retrieveAllComments,
    retrieveAllViews
} from "../../../services/CommentService";
import {ToolTip} from "../tool-tip/ToolTip";
import {formatDateAsString, timeFromDate} from "../../../util/StringUtil";

export const CommentToolTip = ({
                                   context,
                                   contextExternalReference,
                                   contextName,
                                   showToaster,
                                   setSpinnerText,
                                   toolTipsEnabled
                               }) => {

    ReactModal.setAppElement('#root');

    const [message, setMessage] = useState(false);
    const [retrievedCommentList, setRetrievedCommentList] = useState([]);
    const [retrievedViewsList, setRetrievedViewsList] = useState([]);
    const [show, setShow] = useState(false);
    const [seenByVisible, setSeenByVisible] = useState(false);
    const handleClose = () => {
        setShow(false);
        setSeenByVisible(false);
    }

    const setVisible = async (commentExternalReference) => {
        setSeenByVisible(true);
        await fetchAllViews(commentExternalReference);
    }

    const setNotVisible = () => {
        setSeenByVisible(false);
    }

    const handleShow = async () => {
        setShow(true);
        const dt = new Date();
        dt.setHours(dt.getHours() + 2);
        retrievedCommentList.map((CommentVO) => {
            const commentExtRef = CommentVO.externalReference
            const viewToBeSaved = {
                contextExternalReference: commentExtRef,
                systemUserName: context.username,
                timeOfViewing: dt,
            };
            createView(context.username, viewToBeSaved);
        })
    }

    const handleSubmitClick = async () => {
        const commentToBeSaved = {
            comment: message,
            systemUserName: context.username,
            contextExternalReference: contextExternalReference,
            contextName: contextName,
        };
        if (message !== false) {
            if (message.toString().length > 0) {
                setSpinnerText("Saving Comment");
                const response = await createComment(context.username, commentToBeSaved);
                setMessage("");
                await handleResponse(response);
            }
        }
    }

    const handleResponse = async ([data, error]) => {
        if (data) {
            if (data.responseStatus === "Success") {
                await fetchAllComments();
            }
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const fetchAllComments = async () => {
        const [data, error] = await retrieveAllComments(context.username, contextExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                const commentList = data.commentVOS;
                if (commentList) {
                    setRetrievedCommentList(commentList);
                }
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
    }

    const fetchAllViews = async (commentExtRef) => {
        const [data, error] = await retrieveAllViews(context.username, commentExtRef);
        if (data) {
            if (data.responseStatus === "Success") {
                const viewerList = data.viewerVOList;
                if (viewerList) {
                    setRetrievedViewsList(viewerList);
                }
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await fetchAllComments();
        }
        fetchData();
    }, []);

    const handleMessageChange = (event) => {
        setMessage(event.target.value);
    }

    const deleteOwnComment = async (commentExternalReference) => {
        setSpinnerText("Deleting Comment");
        let commentDeleted = false;
        const [data, error] = await deleteComment(context.username, commentExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                commentDeleted = true;
            }
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }

        if (commentDeleted) {
            await fetchAllComments();
        }
        setSpinnerText(null);
    }

    return (
        <div className="tooltip-container-c">
            <div>
                <button className="info-icon-c" onClick={handleShow}>
                    <img src={retrievedCommentList.length === 0 ? commentsEmptyIcon : commentsFullIcon}
                         alt={"comments-icon"} className={"comments-icon-c"}/>
                </button>
            </div>

            <ReactModal isOpen={show} className="modal-content-c" overlayClassName="modal-overlay">
                <div className={"header-container-c"}>
                    {seenByVisible ?
                        <div className={"modal-header-c"}>Seen by</div> :
                        <div className={"modal-header-c"}>Comments</div>}
                    {toolTipsEnabled &&
                    <ToolTip setSpinnerText={setSpinnerText} showToaster={showToaster} context={context}
                             fieldName={!seenByVisible ? "Comment" : "Seen by"}
                             tooltipExternalReference={seenByVisible ? "cps123" : "seenby123"}/>}
                </div>
                <div className={"modal-info-group-c"}>
                    {!seenByVisible &&
                    <div className={"text-box-c"}>
                        {retrievedCommentList.length > 0 ?
                            <ul className={"comment-container"}>
                                {retrievedCommentList.map((commentObj, index) => (
                                    <li key={index} className={"comment-message-container"}>
                                        <div className={"prompt-container"}>
                                            <button className={"seen-by-button"}
                                                    onClick={() => setVisible(commentObj.externalReference)}>
                                                <FontAwesomeIcon className="eye-icon" icon={faEye}/>
                                            </button>
                                            {commentObj.systemUserName}&nbsp;
                                            <span className={"comments-time-container"}>
                                                ({formatDateAsString(commentObj.creationDate)} - {timeFromDate(commentObj.creationDate)})
                                            </span>
                                            {context.username === commentObj.systemUserName &&
                                            <button className={"button-delete-comment"}
                                                    onClick={() => deleteOwnComment(commentObj.externalReference)}>
                                                <FontAwesomeIcon className="eye-icon" icon={faTrash}/>
                                            </button>}
                                        </div>
                                        <div className={"comment-message"}>{commentObj.comment}</div>
                                    </li>))}<br/>
                            </ul> :
                            <p className={"no-comments-message"}>No comments yet</p>}
                    </div>}
                    {seenByVisible &&
                    <div className={!seenByVisible ? "text-box-c" : "text-box-long"}>
                        {retrievedViewsList.length > 0 ?
                            <ul className={"comment-container"}>
                                {retrievedViewsList.map((viewObj, index) => (
                                    <li key={index} className={"comment-message-container"}>
                                        <div className={"prompt-container-s"}>Seen
                                            by: {viewObj.systemUserName}&nbsp;</div>
                                        <span className={"view-time-container"}>
                                                  - ({formatDateAsString(viewObj.timeOfViewing)} - {timeFromDate(viewObj.timeOfViewing)})
                                            </span>
                                    </li>))}<br/>
                            </ul> :
                            <p className={"no-comments-message"}>No viewers yet</p>}
                    </div>
                    }
                </div>
                {!seenByVisible &&
                <div className={"modal-info-group"}>
                    <textarea className={"text-input-c"} onChange={handleMessageChange}
                              placeholder={"Comment"}/>
                </div>}
                <div className={"modal-button-group"}>
                    <div className={"modal-button-group-mid"}>
                        {seenByVisible ?
                            <StandardButton onClick={setNotVisible} text={"Comment"}/>
                            : <StandardButton onClick={handleClose} text={"Close"}/>}
                        {!seenByVisible &&
                        <StandardButton onClick={handleSubmitClick} text={"Save"}/>}
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
